import './Clients.css';

const clients = [
  { name: 'Ambika',         logo: '/clients/ambika-approvals.jpeg'  },
  { name: 'Abr',            logo: '/clients/abr.jpeg' },
  { name: 'Ak',             logo: '/clients/ak.jpeg'  },
  { name: 'Anuj',           logo: '/clients/anuj.jpeg'   },
  { name: 'Cake',           logo: '/clients/cake.jpeg' },
  { name: 'Chakkra',        logo: '/clients/chakkra.jpeg'  },
  { name: 'Happymack',      logo: '/clients/happy-mack.jpeg' },
  { name: 'kolampukitchen', logo: '/clients/kolambu-kitchen.jpeg'  },
  { name: 'rbs',            logo: '/clients/rbs.jpeg'   },
  { name: 'sound',          logo: '/clients/sound-emp.jpeg' },
  
];

// Duplicate for seamless infinite marquee
const track = [...clients, ...clients, ...clients];

export default function Clients() {
  return (
    <section className="clients-section">
      <div className="clients-label reveal">
        <span>Our Best Clients</span>
        <div className="clients-line" />
        <span className="clients-trust-badge">Trusted by 500+ brands</span>
      </div>

      <div className="clients-marquee-wrap">
        <div className="clients-track">
          {track.map((c, i) => (
            <div key={i} className="client-logo-card">
              <img src={c.logo} alt={c.name} className="client-logo-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
